import { useEffect } from "react"
import { useHistory } from "react-router"
import {
  getImpersonatedUserData,
  getEnteringImpersonationFlag,
  removeImpersonatedUserData,
  removeEnteringImpersonationFlag,
  setCurrentUserForImpersonationLogin
} from "../helpers/impersonationStorageManage"

// Hook for correct login from original user's account to impersonated user's account
export const useEnteringImpersonationManage = (args: { isAuthed: boolean }) => {
  const { isAuthed } = args

  const history = useHistory()

  useEffect(() => {
    // Get flag value for checking: is it login from original user to the impersonated user
    const isEnteringImpersonation = getEnteringImpersonationFlag()

    // If we are on the account and `isEnteringImpersonation` is equal to true ->
    // we should remove this flag and impersonated user data from storage
    if (!!isAuthed && !!isEnteringImpersonation) {
      removeImpersonatedUserData()
      removeEnteringImpersonationFlag()

      return
    }

    // Return from hook if we are authed
    // or `isEnteringImpersonation` flag is equal to false
    if (!!isAuthed || !isEnteringImpersonation) {
      return
    }

    // Get impersonated user data
    const impersonatedUserData = getImpersonatedUserData()

    // If we don't have `authUrl` for impersonated user -> need to return
    if (!impersonatedUserData?.authUrl) {
      return
    }

    // Setting impersonated user's data to `user` storage value for correct login
    setCurrentUserForImpersonationLogin(impersonatedUserData)

    // Move to the `auth/token` page for login by token
    history.replace(impersonatedUserData.authUrl)
  }, [isAuthed])
}
